import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {SettingsDependencies} from '../dependencies';
import {keys} from './keys';

export type ListRemindersQueryDependencies = Pick<SettingsDependencies, 'controllers'>;

export const listRemindersQuery = ({controllers}: ListRemindersQueryDependencies) =>
  queryOptions({
    queryKey: keys.reminders(),
    queryFn: () => controllers.settingsController.listReminders().then(unwrap),
  });
